var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.93 416.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9bcea4;}.cls-1,.cls-3,.cls-4,.cls-5{stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:3.94px;}.cls-2,.cls-3,.cls-5,.cls-6{fill:#1d1d1b;}.cls-2{opacity:0.3;}.cls-3,.cls-6{opacity:0.2;}.cls-4{fill:#e7ae84;}.cls-5{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 109.07,
    cy: 91.65,
    rx: 47.88,
    ry: 89.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.32,91.33c0,34.84-18.31,66.38-47.89,89.16V2.17C139,25,157.32,56.49,157.32,91.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.54,201.38q-.62,5.94-1.83,11.86a136.59,136.59,0,0,1-5.85,20.35c-2-.23-4-.5-6-.81-19.32-3-37.19-9.52-52.32-19.54a104.05,104.05,0,0,1-30.67-31C3,152.62,1.5,116.45,14.31,81.94a135.75,135.75,0,0,1,50.6,15.67,105.88,105.88,0,0,1,38.39,35.67,96.7,96.7,0,0,1,5.37,9.54c.63,1.28,1.22,2.55,1.79,3.84C118,163.76,120.55,182.45,118.54,201.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.3,133.28c18.87,29.62,20.37,65.81,7.56,100.31L14.31,81.94C51.79,86.2,84.44,103.66,103.3,133.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.57,185.88a101.89,101.89,0,0,1-19.78,27.36c-16.41,16.29-38.32,27.45-63.07,32.92a144,144,0,0,1-5.86-13.38,130.07,130.07,0,0,1-5-16.47c-.23-1-.46-2.05-.67-3.07A116,116,0,0,1,97,196.35a101.43,101.43,0,0,1,10.21-50.72c.47-.94,1-1.88,1.44-2.81s1.17-2.16,1.79-3.22C121,121.46,136.83,107.27,156,97.47a140.91,140.91,0,0,1,34.08-12.11C206.6,118.33,209.07,154.46,193.57,185.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.57,185.88a101.89,101.89,0,0,1-19.78,27.36c-16.41,16.29-38.32,27.45-63.07,32.92L127,213.24,190.07,85.36C206.6,118.33,209.07,154.46,193.57,185.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.79,213.24c-16.41,16.29-38.32,27.45-63.07,32.92a144,144,0,0,1-5.86-13.38c-19.32-3-37.19-9.52-52.32-19.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pot"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.66,260.38l-.5,7.77-8.55,131.53a15.87,15.87,0,0,1-16,14.63H46.35a15.88,15.88,0,0,1-16-14.63L21.78,268.15l-.5-7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219,227.36v25.25a7.88,7.88,0,0,1-8,7.77H10a7.88,7.88,0,0,1-8-7.77V227.36a7.88,7.88,0,0,1,8-7.77H211A7.88,7.88,0,0,1,219,227.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.66 260.38 199.16 268.15 21.78 268.15 21.28 260.38 199.66 260.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.45,226.09v25.25a7.89,7.89,0,0,1-8,7.77H198.14l-.5,7.77L189.1,398.41a15.88,15.88,0,0,1-16,14.63H109V218.32h100.5A7.89,7.89,0,0,1,217.45,226.09Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.d8d0270c75123905593dabaea9421e93.svg";
export { ForwardRef as ReactComponent };